export default __webpack_public_path__ + "media/zurb/img/ecommerce/tmw_comp_1-3301a8f7613f271376eb41c75e4bc704.png";